module.exports = __webpack_public_path__ + "img/icon1.3eb3cba6.svg";